var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selection-container"},[_c('div',{staticClass:"element-detail-row"},[_c('label',{staticClass:"dropdown-field-label query-label"},[_vm._v(" "+_vm._s(_vm.$t("default"))+" ")]),_c('div',{staticClass:"s-fields"},[_c('div',{staticClass:"expression-values"},[_c('div',[_vm._v(_vm._s(_vm.defaultDateValue))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }